<template>
  <Table :columns="columns" :headers="headers">
    <BuildingTableRow
      v-for="building in buildings"
      :key="building.id"
      :building="building"
      :show-portfolio="showPortfolio"
      :show-manager="showManager"
      @select-portfolio="emit('select-portfolio', $event)"
    />
  </Table>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { Table } from '@tallo/design-system';

import { BuildingDto } from '../dtos/building.dto.interface';
import BuildingTableRow from './building-table-row.vue';

/** The buildings as rows: each one's units by status, beside what the cards carry */
const props = defineProps<{
  buildings: BuildingDto[];
  showPortfolio?: boolean;
  showManager?: boolean;
}>();
const emit = defineEmits<{ 'select-portfolio': [portfolioId: string] }>();

const layout = computed(() => [
  { header: 'Building', width: 'minmax(0, 2.4fr)' },
  { header: 'Units', width: '1.8fr' },
  ...(props.showManager ? [{ header: 'Manager', width: '1.4fr' }] : []),
  ...(props.showPortfolio ? [{ header: 'Portfolio', width: '1.2fr' }] : []),
  { header: 'Created', width: '1fr' },
]);
const columns = computed(() => layout.value.map(({ width }) => width).join(' '));
const headers = computed(() => layout.value.map(({ header }) => header));
</script>
